//Library imports
import React from "react";
import styled from "styled-components";
import { Col, Row } from "antd";
//Local imports
import PillTabs from "modules/Common/PillTabs";
import AudiencenSearch from "../AudiencenSearch";
import UserList from "../People/UserList";
import CompanyList from "./CompanyList";
import UserListV2 from "./UserList";
import SelectWithIcon from "../../Shared/SelectWithIcon";
import EditItemName from "modules/Common/Components/EditItemName";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import DetailProfile from "../People/DetailProfile";

import { ReactComponent as Sort } from "../../../../assets/img/icons/Sort.svg";

interface AudienceSearchProps {}

const AudienceSearch: React.FC<AudienceSearchProps> = (props) => {
  return (
    <Wrapper>
      <Row gutter={24}>
        <Col className="gutter-row mb-2" span="24">
          <EditItemName itemName="Audiences" nonEditable={true} />
        </Col>
      </Row>
      <AudiencenSearch ShowSearchIcon={false} ShowRefreshIcon={true} Placeholder="Search Lists..." />
      <Row gutter={24}>
        <Col className="gutter-row mb-2" span="12">
          <PillTabs />
        </Col>
        <Col className="gutter-row mb-3" span="12">
          <div className="d-flex flex-row-reverse mt-3">
            <span className="total-count">4561 items</span>
            <SelectWithIcon
              emoji={<Sort style={{ height: 18, width: 18 }} />}
              defaultValue={{ value: "Result Types", label: "Result Types" }}
              options={[
                { value: "Result Types", label: "Result Types" },
                { value: "All Types", label: "All Types" },
                { value: "Accounts", label: "Accounts" },
                { value: "Lists", label: "Lists" },
                { value: "People", label: "People" },
              ]}
            />
          </div>
        </Col>
        <Col className="gutter-row" span="12">
          <h3>Matching Accounts</h3>
        </Col>
        <Col className="gutter-row" span="12">
          <div className="d-flex flex-row-reverse">
            <span className="view-all">View all</span>
          </div>
        </Col>
        <Col className="gutter-row" span="24">
          <CompanyList />
        </Col>
        <Col className="gutter-row" span="12">
          <h3>Matching lists:</h3>
        </Col>
        <Col className="gutter-row" span="12">
          <div className="d-flex flex-row-reverse">
            <span className="view-all">View all</span>
          </div>
        </Col>
        <Col className="gutter-row" span="24">
          <UserListV2 />
        </Col>
        <Col className="gutter-row" span="12">
          <h3>Matching People:</h3>
        </Col>
        <Col className="gutter-row" span="12">
          <div className="d-flex flex-row-reverse">
            <span className="view-all">View all</span>
          </div>
        </Col>
        <Col className="gutter-row" span="24">
          <UserList />
        </Col>
      </Row>
      <FloatingSidebarTwo isToggle={false} ProfileSidebar={true} className="detail-person-view">
        <DetailProfile />
      </FloatingSidebarTwo>
    </Wrapper>
  );
};

export default AudienceSearch;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 75px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 40px 50px 0 50px;
  }
  h2 {
    color: #424b50;
    font-size: 40px;
    font-weight: 800;
    line-height: 47px;
    margin-bottom: 10px;
    display: block;
    padding-left: 7px;
    font-family: "Roboto Slab", serif;
  }
  h3 {
    color: #424b50;
    font-size: 23px;
    font-weight: 600;
    margin: 0 0 10px 0;
    display: block;
    font-family: "Roboto Slab", serif;
  }
  .total-count {
    color: #7e7e7e;
    font-weight: 500;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    margin: 10px 0 0 10px;
  }
  .view-all {
    color: #27ce0a;
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    cursor: pointer;
  }

  .filters-tabs {
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      li {
        margin: 0px;
        padding: 0;

        &:nth-child(1) {
          button {
            .wrapper {
              border-radius: 8px 0px 0px 8px;
            }
          }
        }
        &:nth-child(2) {
          button {
            .wrapper {
              border-radius: 0 8px 8px 0;
            }
          }
        }
      }
    }
  }
  .search-wraper .search-bar {
    span.clear-search,
    .search-input {
      margin-top: 9px !important;
      margin-bottom: 7px;
    }
    .refresh-search {
      margin-top: 8px !important;
    }
  }
  .head-wrapper {
    display: flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn-wrapper {
      display: flex;
      align-items: center;
      .ml {
        margin-left: 12px;
      }
    }
  }
`;
